import { useState, useEffect } from "react";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { COMPANY } from "./constants";

export default function WelcomePopup() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const popupShown = sessionStorage.getItem('welcomePopupShown');
    if (!popupShown) {
      const timer = setTimeout(() => {
        setIsOpen(true);
        sessionStorage.setItem('welcomePopupShown', 'true');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => setIsOpen(false);
  const handleGetQuote = () => { window.location.href = COMPANY.phoneLink; };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent
        data-testid="welcome-popup"
        className="bg-white border-0 max-w-lg w-[95vw] p-0 rounded-2xl overflow-hidden shadow-2xl"
      >
        <div className="relative h-48 md:h-56 overflow-hidden">
          <img
            src="https://static.prod-images.emergentagent.com/jobs/28e96d12-5831-4088-9150-edb1188d04e4/images/2eba12e30a5f3b8a1c948374af57c4001f12ccd8ebcb7912e7d356144bbed632.png"
            alt="Professional landscaper"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          <div className="absolute top-4 right-4 bg-forest-500 text-white px-4 py-2 rounded-full font-bold text-lg shadow-lg">
            20% OFF
          </div>
        </div>

        <div className="p-6 md:p-8 text-center">
          <h2 className="font-serif text-2xl md:text-3xl text-forest-700 font-bold mb-4">
            Expert Landscaping You Can Trust
          </h2>
          <p className="text-stone-600 mb-4 leading-relaxed">
            Georgia Outdoor Worx delivers <span className="font-semibold text-forest-600">high-end craftsmanship</span> and professional expertise to your lawn and garden. We are fully <span className="font-semibold">licensed and insured</span>, providing the peace of mind and premium results your home deserves.
          </p>
          <div className="bg-sand-100 rounded-xl p-4 mb-6">
            <p className="text-forest-700 font-medium">Claim your special welcome offer:</p>
            <p className="text-2xl font-bold text-forest-600 mt-1">20% OFF your first visit!</p>
          </div>
          <Button
            onClick={handleGetQuote}
            data-testid="welcome-popup-cta"
            className="w-full bg-forest-500 hover:bg-forest-600 text-white font-bold py-4 px-8 rounded-full text-lg transition-all duration-300 hover:scale-105 shadow-lg"
          >
            <Phone className="w-5 h-5 mr-2" />
            GET MY FREE QUOTE
          </Button>
          <button onClick={handleClose} className="mt-4 text-stone-400 hover:text-stone-600 text-sm transition-colors">
            No thanks, maybe later
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
